import 'bootstrap/dist/css/bootstrap.css';
import 'helpers/webpSupport'; // detect WebP support early; sets <html class="webp|no-webp">
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import store from './store/reduxstore';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import ScrollToTop from 'components/Utlility/ScrollToTop';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

let persistor = persistStore(store)

root.render(
    <GoogleOAuthProvider clientId="242492947841-cfgfqrg9a11vjnkn7e63ovbh118j86ip.apps.googleusercontent.com">
        <BrowserRouter basename={baseUrl}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                <ScrollToTop />
                    <App />
                </PersistGate>
            </Provider>
        </BrowserRouter>
    </GoogleOAuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
